export enum AjaxFormErrorCode {
  GeneralFailure,
  HttpFailure,
  ValidationFailure,
  ResponseFailure,
}
